import { ILayer } from '../layer.type';
import { environment } from '../../../../../environments/environment';
import { getCSSColorVariableValue } from '../../../utils';
import { _ } from '../../../utils';
import { getSharedLayer } from './shared';

const SYKE_ATTRIBUTION =
  '<a href="https://www.syke.fi/avointieto" target="_blank">SYKE</a>';

const sharedLayers = [
  getSharedLayer('contour'),
  getSharedLayer('groundWaterAreas'),
  getSharedLayer('drainageAreas'),
  getSharedLayer('basinOutlets'),
  getSharedLayer('houseNumbers')
];

// vectorURL and vectorSourceLayer are filled in from encrypted-data/T14.json by MapService.addLayer
export default function getLayers(): ILayer[] {
  return [
    {
      id: 'Kaivo',
      name: _('Manhole'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-dark-brown.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Tunnus', 'Käyttötila', 'Käyttöönottopäiväys', 'Alue', 'Kaivon_numero', 'Osoite', 'Osoite_2', 'Rakenne', 'Käyttö', 'Pääsy', 'Eristys', 'Ulkopinta', 'Pumpun_alusta', 'Rakennusvuosi', 'Varasyöttöpiste', 'Tyhjennystapa', 'Valaistus', 'Kategoria', 'Kansien_lukumäärä'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Kasettiventtiili',
      name: _('Cassette valve'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-blue.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Käyttötila', 'Omistaja', 'Osoite', 'Halkaisija_(mm),_paluu'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Liittyma',
      name: _('Connection'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/replay-edited.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Rakennustyyppi', 'Kulutusryhmä', 'Liittymänumero', 'Kerrosala_(m²)', 'Lämmitettävä_rakennustilavuus_(m³)', 'Pinta-ala_(m²)', 'Liittymän_osoite', 'Kortteli', 'Tontti', 'Kiinteistötunnus', 'Alue', 'Rakennustyyppi'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Paisuntasailio',
      name: _('Expansion tank'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-blue.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Tunnus', 'Muutettu', 'Käyttötila', 'Laskennallinen_käyttöönottovuosi', 'Alue'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Pumppuasema',
      name: _('Pump station'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Tunnus', 'Muutettu', 'Alue'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Putki',
      name: _('District heating network'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'line',
        sourceType: 'vector',
        clickable: true,
        strokeColor: getCSSColorVariableValue('success-base'),
        strokeWeight: 1,
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Pituus_(m)', 'Tunnus', 'Muutettu', 'Käyttötila', 'Käyttöönottopäiväys', 'Valmistaja', 'Rakennusvuosi', 'Asennusliike'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Solmupiste',
      name: _('Node'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/circle-green.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji'],
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    {
      id: 'Syottopiste',
      name: _('Feed point'),
      orderingWeight: 1,
      belowRoadLayers: false,
      selectable: true,
      style: {
        layerType: 'symbol',
        sourceType: 'vector',
        clickable: true,
        icon: {
          url: environment.assetRoot + '/img/rego/factory-building-edited.png',
          opacity: 0.8,
        },
        visible: false,
      },
      metadata: {
        uniqueBy: 'id',
        labelBy: 'id',
        visibleByZoom: 6,
        hoverComponent: 'ElementDetailsHover',
        hoverProperties: {
          coordinates: false,
          properties: ['Laji', 'Aseman_tai_kaivon_tunnus', 'Polttoaine']
        },
      },
      searchOptions: { searchable: false },
      useWorker: true,
    },
    ...sharedLayers
  ];
}
